// extracted by mini-css-extract-plugin
export default {"root":"_1W6Qb","white":"_3iqSs","themed":"_2OD-r"};